/* Product page behaviour for sections/bsmc-product.liquid and
   sections/bsmc-product-recommendations.liquid.

   Variant selection, availability (with the low-stock override), price,
   quantity stepper, size guide dialog, the review stars in the buy panel, the
   phone gallery, and the "You may also like" fetch. No jQuery: CartJS handles
   the add itself through data-cart-submit on the form. */
(function () {
  'use strict';
  if (window.__bsmcProductInit) return;
  window.__bsmcProductInit = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initProduct(root) {
    var form = root.querySelector('#bsmc-product-form');
    var addBtn = root.querySelector('#addCart');
    var addText = addBtn ? addBtn.querySelector('[data-submit-button-text]') : null;
    var variantInput = root.querySelector('#variantId');
    var priceNow = root.querySelector('[data-product-price]');
    var priceWas = root.querySelector('[data-compare-price]');
    var status = root.querySelector('[data-bsmc-status]');
    var gallery = root.querySelector('[data-bsmc-gallery]');
    var isPreOrder = root.getAttribute('data-preorder') === 'true';
    var lowStockOverride = root.getAttribute('data-low-stock-override') === 'true';
    var text = {
      add: root.getAttribute('data-text-add'),
      soldOut: root.getAttribute('data-text-sold-out'),
      preOrder: root.getAttribute('data-text-pre-order'),
      inStock: root.getAttribute('data-text-in-stock'),
      unavailable: root.getAttribute('data-text-unavailable'),
      choose: root.getAttribute('data-text-choose') || 'Select a [[option]]'
    };

    function say(message) {
      if (status) status.textContent = message;
      if (window.announce) window.announce(message);
    }

    /* ---- Quantity stepper ---- */
    var qtyInput = root.querySelector('#Quantity');
    function setQty(n) {
      n = Math.max(1, Math.floor(n) || 1);
      qtyInput.value = n;
    }
    if (qtyInput) {
      var dec = root.querySelector('[data-bsmc-qty-dec]');
      var inc = root.querySelector('[data-bsmc-qty-inc]');
      if (dec) dec.addEventListener('click', function () { setQty(parseInt(qtyInput.value, 10) - 1); });
      if (inc) inc.addEventListener('click', function () { setQty(parseInt(qtyInput.value, 10) + 1); });
      qtyInput.addEventListener('change', function () { setQty(parseInt(qtyInput.value, 10)); });
    }

    /* ---- Variants ---- */
    var json = root.querySelector('#productVariantsJson');
    var groups = Array.prototype.slice.call(root.querySelectorAll('.product__option-group'));
    if (json && groups.length) {
      var variants = [];
      try { variants = JSON.parse(json.textContent); } catch (e) { variants = []; }
      var totalOptions = groups.length;

      function selectedOptions() {
        var out = {};
        groups.forEach(function (g) {
          var checked = g.querySelector('input[type=radio]:checked');
          if (checked) out[g.getAttribute('data-option-index')] = checked.value;
        });
        return out;
      }

      function findVariant(selected) {
        var keys = Object.keys(selected);
        if (keys.length !== totalOptions) return null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], match = true;
          for (var j = 0; j < keys.length; j++) {
            if (v.options[parseInt(keys[j], 10) - 1] !== selected[keys[j]]) { match = false; break; }
          }
          if (match) return v;
        }
        return null;
      }

      function isAvailable(v) {
        if (!v.available) return false;
        if (v.inventory_policy === 'continue' || v.tracked === false) return true;
        var qty = lowStockOverride ? v.inventory_quantity : v.inventory_quantity - 2;
        return qty > 0;
      }

      function markAvailability(selected) {
        groups.forEach(function (g) {
          var pos = g.getAttribute('data-option-index');
          Array.prototype.forEach.call(g.querySelectorAll('.product__variant'), function (label) {
            var value = label.getAttribute('data-option-value');
            var input = document.getElementById(label.getAttribute('for'));
            var oos;
            var test = {};
            for (var k in selected) test[k] = selected[k];
            test[pos] = value;
            if (Object.keys(test).length === totalOptions) {
              var tv = findVariant(test);
              oos = !tv || !isAvailable(tv);
            } else {
              oos = !variants.some(function (v) {
                if (v.options[parseInt(pos, 10) - 1] !== value) return false;
                for (var k in selected) {
                  if (k !== pos && v.options[parseInt(k, 10) - 1] !== selected[k]) return false;
                }
                return isAvailable(v);
              });
            }
            label.classList.toggle('product__variant--oos', oos);
            if (input) {
              if (oos) input.setAttribute('aria-disabled', 'true');
              else input.removeAttribute('aria-disabled');
            }
          });
          var current = g.querySelector('[data-option-selected]');
          if (current && selected[pos]) current.textContent = selected[pos];
        });
      }

      function showVariantImage(v) {
        if (!gallery || !v.featured_media_id) return;
        var shot = gallery.querySelector('[data-media-id="' + v.featured_media_id + '"]');
        if (!shot) return;
        var phone = window.matchMedia('(max-width: 40em)').matches;
        if (phone) {
          gallery.scrollTo({ left: shot.offsetLeft - gallery.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
        } else {
          var top = shot.getBoundingClientRect().top + window.pageYOffset - 24;
          if (Math.abs(window.pageYOffset - top) > 40) window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      }

      /* The first option group with nothing picked, or null. */
      function missingGroup() {
        for (var i = 0; i < groups.length; i++) {
          if (!groups[i].querySelector('input[type=radio]:checked')) return groups[i];
        }
        return null;
      }

      function updateProduct(v, announceIt) {
        if (!v) {
          var missing = missingGroup();
          if (variantInput) variantInput.value = '';
          /* Not disabled: the notify-me widget reads a disabled button as
             sold out. aria-disabled keeps it inert and announced as such,
             and the submit guard below stops it going through. */
          if (addBtn) { addBtn.disabled = false; addBtn.setAttribute('aria-disabled', 'true'); }
          if (addText) {
            if (missing) {
              var label = missing.querySelector('.bsmc26-pdp__option-label');
              var name = label ? label.childNodes[0].textContent.replace(':', '').trim().toLowerCase() : '';
              addText.textContent = text.choose.replace('[[option]]', name);
            } else {
              addText.textContent = text.unavailable;
            }
          }
          return;
        }
        if (variantInput) variantInput.value = v.id;
        if (addBtn) addBtn.removeAttribute('aria-disabled');
        if (priceNow) priceNow.textContent = v.price_formatted;
        if (priceWas) {
          if (v.compare_at_price > v.price) {
            priceWas.innerHTML = '<span class="bsmc26__sr">' + (priceWas.getAttribute('data-label') || '') + '</span>' + v.compare_at_price_formatted;
            priceWas.hidden = false;
          } else {
            priceWas.hidden = true;
          }
        }
        var availability;
        if (isPreOrder) {
          addBtn.disabled = false; addText.textContent = text.preOrder; availability = text.preOrder;
        } else if (isAvailable(v)) {
          addBtn.disabled = false; addText.textContent = text.add; availability = text.inStock;
        } else {
          addBtn.disabled = true; addText.textContent = text.soldOut; availability = text.soldOut;
        }
        if (window.history && window.history.replaceState) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', url.toString());
          } catch (e) { /* ignore */ }
        }
        if (announceIt) say(v.title + ', ' + v.price_formatted + ', ' + availability);
      }

      function onChange(announceIt) {
        var selected = selectedOptions();
        markAvailability(selected);
        var v = findVariant(selected);
        updateProduct(v, announceIt);
        if (v && announceIt) showVariantImage(v);
      }

      Array.prototype.forEach.call(root.querySelectorAll('.product__variant-input'), function (input) {
        input.addEventListener('change', function () { onChange(true); });
      });

      /* The label carries the screen-reader text for the struck price. */
      if (priceWas) {
        var sr = priceWas.querySelector('.bsmc26__sr');
        if (sr) priceWas.setAttribute('data-label', sr.textContent);
      }

      /* Sync the radios with the variant the page rendered. */
      var currentId = variantInput ? parseInt(variantInput.value, 10) : 0;
      variants.some(function (v) {
        if (v.id !== currentId) return false;
        v.options.forEach(function (value, i) {
          var radio = root.querySelector('input[name="option' + (i + 1) + '"][value="' + value.replace(/"/g, '\\"') + '"]');
          if (radio) radio.checked = true;
        });
        return true;
      });
      onChange(false);
    }

    /* Guard against submitting with nothing chosen: stop the submit, say
       what is missing and move focus to that option group. */
    if (form && addBtn) {
      function nudge() {
        var group = root.querySelector('.product__option-group:not(:has(input[type=radio]:checked))');
        var label = group && group.querySelector('.bsmc26-pdp__option-label');
        var name = label ? label.childNodes[0].textContent.replace(':', '').trim().toLowerCase() : '';
        say(text.choose.replace('[[option]]', name));
        var first = group && group.querySelector('input[type=radio]:not([aria-disabled="true"])');
        if (first) first.focus();
      }
      /* Caught in the capture phase so CartJS's document-level submit and
         click handlers never see it: otherwise it would try to add an empty
         variant and open the cart drawer. */
      addBtn.addEventListener('click', function (e) {
        if (addBtn.getAttribute('aria-disabled') === 'true') {
          e.preventDefault(); e.stopImmediatePropagation(); nudge();
        }
      }, true);
      form.addEventListener('submit', function (e) {
        /* Only the product form itself: the notify-me widget nests its own
           form inside this one and its submit must pass through untouched. */
        if (e.target !== form) return;
        if (addBtn.disabled || addBtn.getAttribute('aria-disabled') === 'true') {
          e.preventDefault(); e.stopImmediatePropagation();
          if (!addBtn.disabled) nudge();
        }
      }, true);
    }

    /* ---- Size guide dialog ---- */
    Array.prototype.forEach.call(root.querySelectorAll('[data-bsmc-size-guide]'), function (btn) {
      var dialog = document.getElementById(btn.getAttribute('data-bsmc-size-guide'));
      if (!dialog) return;
      btn.addEventListener('click', function () {
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        var close = dialog.querySelector('[data-bsmc-dialog-close]');
        if (close) close.focus();
      });
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) dialog.close();
      });
      Array.prototype.forEach.call(dialog.querySelectorAll('[data-bsmc-dialog-close]'), function (close) {
        close.addEventListener('click', function () { dialog.close(); });
      });
      dialog.addEventListener('close', function () { btn.focus(); });
    });

    /* ---- Review stars in the buy panel ---- */
    var stars = root.querySelector('#bsmc-star-rating');
    if (stars) {
      var render = function (avg, total) {
        var out = '';
        var rounded = Math.round(avg || 0);
        for (var i = 1; i <= 5; i++) {
          var filled = total > 0 && i <= rounded;
          out += '<svg class="' + (filled ? 'is-filled' : 'is-empty') + '" viewBox="0 0 24 24" focusable="false"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
        }
        stars.innerHTML = out + '<span class="bsmc26-pdp__stars-count">(' + (total || 0) + ')</span>';
      };
      render(0, 0);
      fetch(stars.getAttribute('data-api-base') + '/api/reviews/aggregate?shopDomain=' + encodeURIComponent(stars.getAttribute('data-shop-domain')) + '&productHandle=' + encodeURIComponent(stars.getAttribute('data-product-handle')))
        .then(function (r) { return r.json(); })
        .then(function (data) { if (data && data.success) render(data.averageRating || 0, data.totalReviews || 0); })
        .catch(function () { /* keep the empty stars */ });
    }

    /* ---- Lightbox: full-screen photos with prev/next and pointer zoom ---- */
    (function () {
      var box = root.querySelector('[data-bsmc-lightbox]');
      var dataEl = root.querySelector('[data-bsmc-lightbox-media]');
      if (!box || !dataEl) return;
      var media = [];
      try { media = JSON.parse(dataEl.textContent).filter(Boolean); } catch (e) { return; }
      if (!media.length) return;
      var stage = box.querySelector('[data-bsmc-lightbox-stage]');
      var zoomBtn = box.querySelector('[data-bsmc-lightbox-zoom]');
      var img = box.querySelector('[data-bsmc-lightbox-img]');
      var count = box.querySelector('[data-bsmc-lightbox-count]');
      var prev = box.querySelector('[data-bsmc-lightbox-prev]');
      var next = box.querySelector('[data-bsmc-lightbox-next]');
      var counterText = root.getAttribute('data-text-photo-counter') || 'Photo [[i]] of [[n]]';
      var index = 0;
      var opener = null;
      var zoomed = false;

      function setZoom(on) {
        zoomed = on;
        stage.classList.toggle('is-zoomed', on);
        zoomBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
        zoomBtn.setAttribute('aria-label', zoomBtn.getAttribute(on ? 'data-label-out' : 'data-label-in'));
        if (on) {
          /* 2.5x the fitted width, capped at the file's own pixels so it never
             goes soft. Worked out from the stage and the photo's known
             proportions rather than the rendered image, which may still be
             loading after a prev/next and would measure as zero. */
          var m = media[index];
          var ratio = (m.w && m.h) ? m.w / m.h : 0.8;
          var stageW = stage.clientWidth;
          var stageH = stage.clientHeight;
          var fitted = Math.min(stageW, stageH * ratio);
          var w = Math.min(fitted * 2.5, m.w || fitted * 2.5);
          stage.style.setProperty('--bsmc-zoom-w', Math.round(w) + 'px');
          /* Ask for a file at least as wide as the zoomed photo. */
          img.sizes = Math.round(w) + 'px';
          /* Start in the middle, once the new size has laid out (and again
             when the photo finishes loading, since its height comes from the
             file). */
          var centre = function () {
            if (!zoomed) return;
            zoomBtn.style.marginTop = Math.max(0, (stage.clientHeight - zoomBtn.offsetHeight) / 2) + 'px';
            stage.scrollLeft = (stage.scrollWidth - stage.clientWidth) / 2;
            stage.scrollTop = (stage.scrollHeight - stage.clientHeight) / 2;
          };
          requestAnimationFrame(centre);
          if (!img.complete) img.addEventListener('load', centre, { once: true });
        } else {
          stage.style.removeProperty('--bsmc-zoom-w');
          zoomBtn.style.marginTop = '';
          img.sizes = '100vw';
        }
      }

      /* Fetch the neighbours in the background so prev/next is instant. */
      var warmed = {};
      function warm(i) {
        i = (i + media.length) % media.length;
        if (warmed[i]) return;
        warmed[i] = true;
        var pre = new Image();
        pre.sizes = '100vw';
        pre.srcset = media[i].srcset || '';
        pre.src = media[i].src;
      }

      function show(i) {
        index = (i + media.length) % media.length;
        setZoom(false);
        img.sizes = '100vw';
        img.srcset = media[index].srcset || '';
        img.src = media[index].src;
        img.alt = media[index].alt || '';
        warm(index + 1);
        warm(index - 1);
        count.textContent = counterText.replace('[[i]]', index + 1).replace('[[n]]', media.length);
        var single = media.length < 2;
        prev.disabled = single;
        next.disabled = single;
      }

      function open(i, from) {
        opener = from || null;
        show(i);
        if (typeof box.showModal === 'function') box.showModal(); else box.setAttribute('open', '');
        zoomBtn.focus();
      }

      Array.prototype.forEach.call(root.querySelectorAll('[data-bsmc-lightbox-open]'), function (btn) {
        btn.addEventListener('click', function () {
          open(parseInt(btn.getAttribute('data-bsmc-lightbox-open'), 10) || 0, btn);
        });
      });

      prev.addEventListener('click', function () { show(index - 1); });
      next.addEventListener('click', function () { show(index + 1); });
      box.querySelector('[data-bsmc-lightbox-close]').addEventListener('click', function () { box.close(); });
      box.addEventListener('close', function () { setZoom(false); if (opener) opener.focus(); });
      box.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
      });
      /* Click on the dark surround closes, click on the photo toggles zoom. */
      box.addEventListener('click', function (e) {
        if (e.target === box || e.target === stage) box.close();
      });
      zoomBtn.addEventListener('click', function () { setZoom(!zoomed); });

      /* eBay-style pan: while zoomed, the pointer's position across the
         stage maps to the scroll position, so moving the mouse looks around. */
      stage.addEventListener('pointermove', function (e) {
        if (!zoomed || e.pointerType === 'touch') return;
        var r = stage.getBoundingClientRect();
        var x = Math.min(Math.max((e.clientX - r.left) / r.width, 0), 1);
        var y = Math.min(Math.max((e.clientY - r.top) / r.height, 0), 1);
        stage.scrollLeft = (stage.scrollWidth - stage.clientWidth) * x;
        stage.scrollTop = (stage.scrollHeight - stage.clientHeight) * y;
      });

      /* Swipe between photos on touch when not zoomed. */
      var touchX = null;
      stage.addEventListener('touchstart', function (e) { touchX = zoomed ? null : e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (touchX === null) return;
        var dx = e.changedTouches[0].clientX - touchX;
        if (Math.abs(dx) > 50) show(dx < 0 ? index + 1 : index - 1);
        touchX = null;
      }, { passive: true });
    })();

    /* ---- Phone gallery: a scrolling strip must be reachable by keyboard ---- */
    if (gallery) {
      var checkScroll = function () {
        var scrolls = gallery.scrollWidth > gallery.clientWidth + 4;
        if (scrolls) {
          gallery.setAttribute('tabindex', '0');
          gallery.setAttribute('role', 'region');
          gallery.setAttribute('aria-label', gallery.getAttribute('data-label') || 'Product photos');
        } else {
          gallery.removeAttribute('tabindex');
          gallery.removeAttribute('role');
          gallery.removeAttribute('aria-label');
        }
      };
      checkScroll();
      window.addEventListener('resize', checkScroll);
    }
  }

  /* ---- You may also like ---- */
  function initRecommendations(section) {
    var url = section.getAttribute('data-url');
    var body = section.querySelector('[data-bsmc-recs-body]');
    if (!url || !body) return;
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-bsmc-recs-body]');
        if (fresh && fresh.querySelector('.bsmc26-card')) {
          body.innerHTML = fresh.innerHTML;
          section.hidden = false;
        }
      })
      .catch(function () { /* keep whatever rendered */ });
  }

  /* The theme's header is position: fixed, so the sticky panel and the
     reviews anchor both need to know how tall it is. */
  function measureHeader() {
    var header = document.getElementById('header__container');
    var h = header ? header.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--bsmc-header-h', Math.round(h) + 'px');
  }

  function init() {
    measureHeader();
    window.addEventListener('resize', measureHeader);
    Array.prototype.forEach.call(document.querySelectorAll('[data-bsmc-pdp]'), initProduct);
    Array.prototype.forEach.call(document.querySelectorAll('[data-bsmc-recs]'), initRecommendations);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Theme editor: re-run when a section is re-rendered. */
  document.addEventListener('shopify:section:load', function (e) {
    var pdp = e.target.querySelector('[data-bsmc-pdp]');
    if (pdp) initProduct(pdp);
    var recs = e.target.querySelector('[data-bsmc-recs]');
    if (recs) initRecommendations(recs);
  });
})();
